import { WinkEmojiDivider } from '@openeducation/oe-rn-components';
import * as React from 'react';

import { PCMessage } from '../pc-message/pc-message';

export const NoPCPendingFeedbacks = () => {
  return (
    <PCMessage
      title="You have no pending feedback!"
      body="Close this tab and navigate back to the Teacher Portal."
      divider={<WinkEmojiDivider />}
    />
  );
};
